import { Controller } from 'react-hook-form';

import { SxProps, TextField } from '@mui/material';

export interface BasicTextareaProps {
  label: string;
  helperText?: string;
  control: any;
  inputName: string;
  maxLength: number;
  disabled?: boolean;
  rows?: number | undefined;
  bgColor?: string;
  required?: boolean;
  onKeyDown?: any;
  isMultiline?: boolean;
}

const getStyles = (background: string): { [key: string]: SxProps } => {
  return {
    description: {
      '& .MuiInputBase-input': {
        lineHeight: 1.25,
        fontSize: '1.6rem',
      },
      '& .MuiInputBase-root': {
        background: background,
      },
      '& .MuiInputBase-inputMultiline': {
        padding: '8px',
      },
    },
  };
};

export default function BasicTextarea(props: BasicTextareaProps) {
  const {
    disabled = false,
    control,
    label,
    inputName,
    maxLength,
    rows,
    bgColor = '#ffffff',
    helperText,
    required = false,
    isMultiline = true,
    onKeyDown,
  } = props;

  const styles = getStyles(bgColor);

  return (
    <Controller
      name={inputName}
      control={control}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          name={inputName}
          required={required}
          label={label}
          placeholder="Type here..."
          rows={rows}
          error={!!fieldState.error}
          onKeyDown={(e) => {
            onKeyDown && onKeyDown(e);
          }}
          multiline={isMultiline}
          inputProps={
            (maxLength && {
              maxLength: maxLength,
            }) ||
            {}
          }
          InputLabelProps={
            {
              shrink: true,
            } as any
          }
          helperText={
            fieldState.error?.message || helperText || (maxLength ? `${field.value?.length || 0}/${maxLength}` : null)
          }
          disabled={disabled}
          sx={styles.description}
        />
      )}
    />
  );
}
